<template>
	<div class="signup">
		<b-form class="form landing-form">
			<router-link to="/" class="modal-logo">
				<img src="../../assets/logo_en.svg" width="129" alt="" />
			</router-link>
			<h3 v-if="!isSuccess" class="mt-4 mb-3 font-weight-normal">
				{{ 'Registration' | translate }}
			</h3>
			<div v-if="!isSuccess" class="signup-form">
				<b-form-group class="form-group-custom">
					<b-form-input
						id="parent_name"
						:placeholder="'First name' | translate"
						:state="!!kidName.isNotValid ? false : null"
						v-model="kidName.value"
						type="text"
						required
					></b-form-input>
					<p class="text-error" v-show="!!kidName.isNotValid">
						{{ kidName.isNotValid | translate }}
					</p>
				</b-form-group>
				<b-form-group class="form-group-custom">
					<b-form-input
						id="parent_name"
						:placeholder="'Last name' | translate"
						:state="kidSurname.isNotValid ? false : null"
						v-model="kidSurname.value"
						type="text"
						required
					>
					</b-form-input>
					<p class="text-error" v-show="!!kidSurname.isNotValid">
						{{ kidSurname.isNotValid | translate }}
					</p>
				</b-form-group>
				<b-form-group class="form-group-custom">
					<b-form-input
						id="email"
						:placeholder="'Email' | translate"
						:state="email.isNotValid ? false : null"
						v-model="email.value"
						type="email"
						required
					></b-form-input>
					<p class="text-error" v-show="!!email.isNotValid">
						{{ email.isNotValid | translate }}
					</p>
				</b-form-group>
				<b-form-group class="form-group-custom form-group-age">
					<select
						v-model="age.value"
						class="select"
						:class="age.isNotValid && 'not-valid'"
						required
					>
						<option :value="null" disabled
							>{{ 'Year of birth' | translate }}
						</option>
						<option v-for="(age, index) in ages" :value="age" :key="index">
							{{ age }}
						</option>
					</select>
					<p class="text-error" v-show="!!age.isNotValid">
						{{ age.isNotValid | translate }}
					</p>
				</b-form-group>
				<b-form-group class="form-group-custom">
					<b-form-input
						id="parent_name"
						:placeholder="'Parents name' | translate"
						:state="!!parentName.isNotValid ? false : null"
						v-model="parentName.value"
						type="text"
						required
					>
					</b-form-input>
					<p class="text-error" v-show="!!parentSurname.isNotValid">
						{{ parentSurname.isNotValid | translate }}
					</p>
				</b-form-group>
				<b-form-group class="form-group-custom">
					<b-form-input
						id="parent_name"
						:placeholder="'Surname of parents' | translate"
						:state="!!parentSurname.isNotValid ? false : null"
						v-model="parentSurname.value"
						type="text"
						required
					>
					</b-form-input>
					<p class="text-error" v-show="!!parentSurname.isNotValid">
						{{ parentSurname.isNotValid | translate }}
					</p>
				</b-form-group>

				<div class="form-group-phone">
					<div :class="phone.isNotValid ? 'phone-error' : ''" class="phone">
						<VuePhoneNumberInput
							default-country-code="UA"
							required
							:state="!!phone.isNotValid ? false : null"
							show-code-on-list
							fetch-country
							v-model="phone.value"
							error-color="#f11212"
						/>
					</div>
					<p class="text-error" v-show="!!phone.isNotValid">
						{{ phone.isNotValid | translate }}
					</p>
				</div>
				<b-form-group class="form-group-custom">
					<b-form-input
						id="country"
						:placeholder="'Country' | translate"
						:state="!!country.isNotValid ? false : null"
						v-model="country.value"
						type="text"
						required
					></b-form-input>
					<p class="text-error" v-show="!!country.isNotValid">
						{{ country.isNotValid | translate }}
					</p>
				</b-form-group>

				<b-form-group class="form-group-custom">
					<b-form-input
						:placeholder="'City' | translate"
						:state="!!city.isNotValid ? false : null"
						v-model="city.value"
						type="text"
						required
					></b-form-input>
					<p class="text-error" v-show="!!city.isNotValid">
						{{ city.isNotValid | translate }}
					</p>
				</b-form-group>
				<b-form-group class="form-group-custom">
					<b-form-input
						:placeholder="'School' | translate"
						:state="!!school.isNotValid ? false : null"
						v-model="school.value"
						type="text"
						required
					></b-form-input>
					<p class="text-error" v-show="!!school.isNotValid">
						{{ school.isNotValid | translate }}
					</p>
				</b-form-group>
				<b-form-group class="form-group-custom">
					<div class="wrap-password">
						<b-form-input
							:placeholder="'Password' | translate"
							:state="!!password.isNotValid ? false : null"
							v-model="password.value"
							:type="password.show ? 'text' : 'password'"
							required
						>
						</b-form-input>
						<button
							type="button"
							@click="password.show = !password.show"
							class="btn-show-password"
						>
							<svg
								v-if="password.show"
								width="21"
								height="16"
								viewBox="0 0 21 16"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M19.9185 7.6C17.8992 2.91 14.1005 0 10.002 0C5.90338 0 2.10471 2.91 0.0854088 7.6C0.0303647 7.72617 0.00195312 7.86234 0.00195312 8C0.00195313 8.13766 0.0303647 8.27383 0.0854088 8.4C2.10471 13.09 5.90338 16 10.002 16C14.1005 16 17.8992 13.09 19.9185 8.4C19.9735 8.27383 20.002 8.13766 20.002 8C20.002 7.86234 19.9735 7.72617 19.9185 7.6V7.6ZM10.002 14C6.83306 14 3.8341 11.71 2.10471 8C3.8341 4.29 6.83306 2 10.002 2C13.1708 2 16.1698 4.29 17.8992 8C16.1698 11.71 13.1708 14 10.002 14ZM10.002 4C9.2111 4 8.43801 4.2346 7.78045 4.67412C7.12288 5.11365 6.61037 5.73836 6.30772 6.46927C6.00508 7.20017 5.92589 8.00444 6.08018 8.78036C6.23447 9.55629 6.6153 10.269 7.17451 10.8284C7.73373 11.3878 8.44621 11.7688 9.22186 11.9231C9.99752 12.0775 10.8015 11.9983 11.5322 11.6955C12.2628 11.3928 12.8873 10.8801 13.3267 10.2223C13.766 9.56448 14.0006 8.79113 14.0006 8C14.0006 6.93913 13.5793 5.92172 12.8294 5.17157C12.0795 4.42143 11.0624 4 10.002 4V4ZM10.002 10C9.60653 10 9.21998 9.8827 8.8912 9.66294C8.56242 9.44318 8.30616 9.13082 8.15484 8.76537C8.00352 8.39991 7.96392 7.99778 8.04107 7.60982C8.11821 7.22186 8.30863 6.86549 8.58823 6.58579C8.86784 6.30608 9.22408 6.1156 9.61191 6.03843C9.99974 5.96126 10.4017 6.00087 10.7671 6.15224C11.1324 6.30362 11.4446 6.55996 11.6643 6.88886C11.884 7.21776 12.0013 7.60444 12.0013 8C12.0013 8.53043 11.7906 9.03914 11.4157 9.41421C11.0407 9.78929 10.5322 10 10.002 10Z"
									fill="#3B3E44"
								/>
							</svg>
							<svg
								v-else
								width="21"
								height="20"
								viewBox="0 0 21 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M8.94162 4.08207C9.29221 4.02833 9.64641 4.0016 10.0011 4.00211C13.1795 4.00211 16.1681 6.29098 17.9072 9.99915C17.6412 10.5635 17.3408 11.1109 17.0076 11.6383C16.9019 11.8021 16.8463 11.9931 16.8477 12.1881C16.8499 12.4062 16.9235 12.6176 17.0571 12.79C17.1907 12.9625 17.377 13.0865 17.5877 13.1431C17.7984 13.1997 18.0218 13.1859 18.2238 13.1037C18.4259 13.0215 18.5955 12.8754 18.7068 12.6878C19.1725 11.9561 19.577 11.1872 19.9162 10.389C19.9698 10.2642 19.9975 10.1299 19.9975 9.99415C19.9975 9.85839 19.9698 9.72406 19.9162 9.59935C17.8972 4.91166 14.0991 2.0031 10.0011 2.0031C9.532 2.00074 9.06365 2.04088 8.60179 2.12304C8.47054 2.14536 8.34496 2.1933 8.23223 2.26415C8.1195 2.33499 8.02184 2.42735 7.9448 2.53594C7.86777 2.64453 7.81288 2.76723 7.78326 2.89704C7.75365 3.02684 7.74989 3.16121 7.7722 3.29246C7.79452 3.42372 7.84246 3.5493 7.91331 3.66202C7.98415 3.77475 8.07651 3.87242 8.1851 3.94945C8.29369 4.02649 8.41639 4.08138 8.5462 4.11099C8.676 4.14061 8.81037 4.14437 8.94162 4.12205V4.08207ZM1.7152 0.293946C1.62201 0.200754 1.51137 0.126829 1.38961 0.0763941C1.26785 0.0259587 1.13734 0 1.00555 0C0.873754 0 0.743251 0.0259587 0.621489 0.0763941C0.499727 0.126829 0.389092 0.200754 0.295899 0.293946C0.107689 0.482157 0.00195312 0.737425 0.00195312 1.0036C0.00195313 1.26977 0.107689 1.52503 0.295899 1.71324L3.39437 4.80172C1.98064 6.16257 0.855479 7.79422 0.0860031 9.59935C0.030967 9.72545 0.0025596 9.86156 0.0025596 9.99915C0.0025596 10.1367 0.030967 10.2728 0.0860031 10.3989C2.105 15.0866 5.90313 17.9952 10.0011 17.9952C11.7973 17.9828 13.5511 17.448 15.0486 16.456L18.287 19.7043C18.3799 19.798 18.4905 19.8724 18.6123 19.9231C18.7341 19.9739 18.8647 20 18.9967 20C19.1286 20 19.2592 19.9739 19.381 19.9231C19.5028 19.8724 19.6134 19.798 19.7063 19.7043C19.8 19.6114 19.8743 19.5009 19.9251 19.3791C19.9758 19.2573 20.002 19.1266 20.002 18.9947C20.002 18.8628 19.9758 18.7321 19.9251 18.6103C19.8743 18.4885 19.8 18.378 19.7063 18.2851L1.7152 0.293946ZM8.07205 9.4794L10.5208 11.9282C10.3519 11.9766 10.1768 12.0002 10.0011 11.9982C9.47093 11.9982 8.96247 11.7875 8.58759 11.4127C8.2127 11.0378 8.00209 10.5293 8.00209 9.99915C8.00004 9.82342 8.02361 9.64833 8.07205 9.4794ZM10.0011 15.9962C6.82267 15.9962 3.83415 13.7073 2.105 9.99915C2.75077 8.5736 3.6673 7.28707 4.80367 6.21102L6.5728 8.00014C6.15725 8.75856 5.99882 9.63127 6.12128 10.4874C6.24374 11.3435 6.64048 12.1368 7.25199 12.7483C7.86349 13.3598 8.6568 13.7565 9.51289 13.879C10.369 14.0014 11.2417 13.843 12.0001 13.4275L13.5893 14.9967C12.501 15.6372 11.2639 15.9818 10.0011 15.9962Z"
									fill="#3B3E44"
								/>
							</svg>
						</button>
					</div>
					<p class="text-error" v-show="!!password.isNotValid">
						{{ password.isNotValid | translate }}
					</p>
				</b-form-group>

				<p class="form-mail-message">
					{{
						'Після реєстрації вам надійде лист з логіном і паролем' | translate
					}}
				</p>

				<button
					:disabled="loading"
					@click.prevent="signIn"
					class="button-custom button-pink mb-2"
				>
					{{ 'Registration' | translate }}
				</button>
				<b-form-invalid-feedback :state="!!signError ? false : null">
					{{ signError | translate }}
				</b-form-invalid-feedback>
			</div>
			<div v-else>
				<h2 class="mt-5">
					{{ 'You are successfully registered' | translate }}
				</h2>
				<button
					class="btn btn-cabinet btn-register"
					@click.prevent="handleSignIn"
				>
					{{ 'Signin' | translate }}
				</button>
			</div>
		</b-form>
	</div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import ModalAddNotification from '../../components/Dashboard/Modal/AddNotification'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'

@Component({
	components: {
		ModalAddNotification,
		VuePhoneNumberInput,
	},
})
export default class RegistrationTrialLes extends Vue {
	regexEmail =
		'^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$'

	kidName = {
		value: '',
		isNotValid: null,
	}
	kidSurname = {
		value: '',
		isNotValid: null,
	}
	email = {
		value: '',
		isNotValid: null,
	}
	age = {
		value: null,
		isNotValid: null,
	}
	parentSurname = {
		value: null,
		isNotValid: null,
	}
	parentName = {
		value: null,
		isNotValid: null,
	}
	phone = {
		value: '',
		isNotValid: null,
	}
	country = {
		value: '',
		isNotValid: null,
	}
	city = {
		value: '',
		isNotValid: null,
	}
	school = {
		value: '',
		isNotValid: null,
	}
	password = {
		value: '',
		isNotValid: null,
		show: false,
	}

	signError = ''

	loading = false
	isSuccess = false

	ages = [
		2005,
		2006,
		2007,
		2008,
		2009,
		2010,
		2011,
		2012,
		2013,
		2014,
		2015,
		2016,
	]

	handleSignIn() {
		this.$emit('login')
		this.isSuccess = false
	}

	resetError() {
		this.kidName.isNotValid = null
		this.kidSurname.isNotValid = null
		this.email.isNotValid = null
		this.age.isNotValid = null
		this.parentName.isNotValid = null
		this.parentSurname.isNotValid = null
		this.phone.isNotValid = null
		this.country.isNotValid = null
		this.city.isNotValid = null
		this.school.isNotValid = null
		this.password.isNotValid = null
	}

	resetField() {
		this.kidName = {
			value: '',
			isNotValid: null,
		}
		this.kidSurname = {
			value: '',
			isNotValid: null,
		}
		this.email = {
			value: '',
			isNotValid: null,
		}
		this.age = {
			value: null,
			isNotValid: null,
		}
		this.parentSurname = {
			value: null,
			isNotValid: null,
		}
		this.phone = {
			value: '',
			isNotValid: null,
		}
		this.country = {
			value: '',
			isNotValid: null,
		}
		this.city = {
			value: '',
			isNotValid: null,
		}
		this.school = {
			value: '',
			isNotValid: null,
		}
		this.password = {
			value: '',
			isNotValid: null,
		}
		this.signError = ''
	}

	signIn() {
		this.resetError()
		this.loading = false
		const input_code = document.querySelector(
			'.signUp .country-selector__input'
		)
		const code_value = input_code.value
		if (!this.kidName.value) {
			this.kidName.isNotValid = 'Field is required'
		}
		if (!this.kidSurname.value) {
			this.kidSurname.isNotValid = 'Field is required'
		}
		if (!this.email.value) {
			if (!this.email.value.match(this.regexEmail)) {
				this.email.isNotValid = 'Enter a valid email address.'
			} else {
				this.email.isNotValid = 'Field is required'
			}
		}
		if (!this.age.value) {
			this.age.isNotValid = 'Select age'
		}
		if (!this.parentName.value) {
			this.parentName.isNotValid = 'Field is required'
		}
		if (!this.parentSurname.value) {
			this.parentSurname.isNotValid = 'Field is required'
		}
		if (!this.phone.value) {
			this.phone.isNotValid = 'Field is required'
		} else if (this.phone.value.length >= 11 || this.phone.value.length < 8) {
			this.phone.isNotValid = 'The phone number entered is not valid'
		}
		if (!this.country.value) {
			this.country.isNotValid = 'Field is required'
		}
		if (!this.city.value) {
			this.city.isNotValid = 'Field is required'
		}
		if (!this.school.value) {
			this.school.isNotValid = 'Field is required'
		}
		if (!this.password.value) {
			this.password.isNotValid = 'Field is required'
		}
		if (this.password.value.length > 20) {
			this.password.isNotValid = 'Max length 20 chars'
		}

		if (
			!this.kidName.value ||
			!this.kidSurname.value ||
			!this.phone.value ||
			!this.parentName.value ||
			!this.parentSurname.value ||
			!this.age.value ||
			!this.country.value ||
			!this.city.value ||
			!this.school.value
		)
			return

		this.loading = true
		this.signError = ''
		this.axios({
			method: 'post',
			url: 'users/create-student',
			data: {
				email: this.email.value,
				first_name: this.kidName.value,
				last_name: this.kidSurname.value,
				phone_number: code_value + this.phone.value,
				birth_year: this.age.value,
				parent_first_name: this.parentName.value,
				parent_last_name: this.parentSurname.value,
				country: this.country.value,
				city: this.city.value,
				school: this.school.value,
				password: this.password.value,
			},
		})
			.then(response => {
				if (response.data.ok) {
					this.isSuccess = true
					this.resetField()
					// window.location.reload()
				}
			})
			.catch(e => {
				const response = e?.response?.data
				if (response?.email) {
					this.email.isNotValid = response.email?.[0]
					return
				}
				if (response?.birth_year) {
					this.age.isNotValid = response.birth_year?.[0]
					return
				}
				if (response?.phone_number) {
					this.phone.isNotValid = response.phone_number?.[0]
				}
				this.signError = 'pageShop.toast.error'
			})
			.finally(() => {
				this.loading = false
			})
	}
}
</script>
<style lang="scss" scoped>
.wrap-password {
	position: relative;

	.is-invalid {
		background-image: none !important;
	}

	input {
		padding-right: 40px !important;
	}
}

.btn-show-password {
	position: absolute;
	outline: none;
	border: none;
	background-color: transparent;
	top: 50%;
	right: 10px;
	transform: translateY(-50%);
}

.btn-register {
	background: #03ce03 !important;
	color: #fff;
	margin: 20px;
}

.select {
	padding: 10px;
	color: #495057;
	background-color: transparent;
}

.text-error {
	color: #b00202;
	text-align: left;
	margin-bottom: 0;
	margin-top: 2px;
}

.form.landing-form {
	padding: 0;
	box-shadow: none;
	max-width: 500px !important;
	margin: 0;
}

.signup-form {
	fieldset {
		margin: 0 !important;
	}

	padding: 20px;

	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 20px;

	@media (max-width: 560px) {
		grid-template-columns: 1fr;
		padding: 0;
	}

	> div {
		margin: 0 !important;
	}

	> *:nth-child(3) {
		grid-column-start: 1;
		grid-column-end: -1;
	}

	.form-group-age {
		grid-column-start: 1;
		grid-column-end: -1;
	}

	.form-group-phone {
		grid-column-start: 1;
		grid-column-end: -1;

		.phone {
			margin: 0;
		}
	}

	.form-mail-message {
		grid-column-start: 1;
		grid-column-end: -1;
		margin: 0;
	}

	& > button {
		grid-column-start: 1;
		grid-column-end: -1;
		background-color: #03ce03 !important;
	}

	.not-valid {
		border: 1px solid red !important;
	}
}
</style>
